import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './template.pug';
import defaultIcon from './icon.pug';

const alertCssClasses = {
  Error: 'alert-danger',
  Warning: 'alert-warning',
  Confirmation: 'alert-success',
  Info: 'alert-info',
};

export default class AlertView extends DeterministicView {
  get attributes() {
    return {
      role: 'listitem',
    };
  }

  get tagName() {
    return 'li';
  }

  get events() {
    return {
      'click .alert__action': () => this.getState().action.callback(),
      'click .alert-ignore': () => {
        this.trigger('ignore');
        this.remove();
      },
    };
  }

  remove() {
    this.$el.slideUp();
    super.remove();
  }

  get template() {
    return ({
      model,
    }) => {
      const {
        level = 'Confirmation',
        hasIcon = false,
        customCssClass,
        icon = defaultIcon,
        dismissible = level !== 'Error',
        message,
        action,
      } = model;
      const cssClass = customCssClass || alertCssClasses[level];

      return template({
        cssClass,
        level,
        hasIcon,
        icon: _.isFunction(icon) ? icon(model) : icon,
        dismissible,
        message,
        action,
      });
    };
  }
}
